import styled from "styled-components";

export const StyledApp = styled.div<any>`
  background-color: ${({ theme }) => theme.white.main};
  width: 100%;
  padding-left: ${({ collapse }) => (!collapse ? "270px" : "80px")};
  transition: width, left, right, 0.3s;
  overflow: auto;
`;
